// extracted by mini-css-extract-plugin
export default {"imageWrapper":"_M-z","twoColumnImage":"aN-z"};